const FIELDS = [
  ['x', '가로 위치', 'number'], ['y', '세로 위치', 'number'],
  ['width', '너비', 'number'], ['height', '높이', 'number'], ['rotate', '회전', 'number'],
  ['fontSize', '글자 크기', 'number'], ['fontFamily', '글꼴', 'text'],
  ['color', '글자 색', 'text'], ['fillColor', '채우기 색', 'text'],
  ['strokeColor', '테두리 색', 'text'], ['strokeWidth', '테두리 두께', 'number'],
];

/** One selection inspector for every native canvas, independent of its template. */
export function mountCanvasProperties({ getEditor, run, onEdited }) {
  const element = document.createElement('section');
  element.className = 'es-work-panel'; element.dataset.testid = 'studio-canvas-properties';
  const title = document.createElement('h3'); title.textContent = '위치 · 크기 · 디자인';
  const select = document.createElement('select');
  select.setAttribute('aria-label', '캔버스 요소'); select.dataset.testid = 'studio-canvas-element';
  const fields = document.createElement('div');
  element.append(title, select, fields);
  let selectedId = null, selectedEditor = null, controls = [];
  const refresh = () => {
    const editor = getEditor(); element.hidden = !editor;
    if (!editor) { selectedId = null; selectedEditor = null; fields.replaceChildren(); return; }
    const layers = editor.getLayers();
    const selected = editor.getSelection();
    const current = selected.length === 1 ? layers.find(layer => layer.id === selected[0].id) : null;
    select.replaceChildren(new Option(selected.length > 1 ? `${selected.length}개 선택됨` : '요소를 선택하세요', ''),
      ...layers.map(layer => new Option(layer.label || layer.type, layer.id)));
    select.value = current?.id ?? '';
    if (selectedEditor !== editor || selectedId !== current?.id) {
      selectedEditor = editor; selectedId = current?.id; controls = []; fields.replaceChildren();
      if (!current) return;
      for (const [key, label, type] of FIELDS) {
        if (!current.editableProperties.includes(key)) continue;
        const input = document.createElement('input'); input.type = type;
        input.setAttribute('aria-label', label); input.dataset.testid = `studio-canvas-${key}`;
        if (type === 'number') input.step = 'any';
        const field = document.createElement('label'); field.className = 'es-work-field';
        const name = document.createElement('span'); name.textContent = label; field.append(name, input); fields.append(field);
        const id = current.id;
        input.addEventListener('change', () => { void run(async () => {
          if (getEditor() !== editor || editor.getSelection().length !== 1 || editor.getSelection()[0].id !== id) {
            throw new Error('선택한 요소가 바뀌었습니다. 다시 선택해 주세요.');
          }
          const value = type === 'number' ? Number(input.value) : input.value.trim();
          if (type === 'number' && (!input.value.trim() || !Number.isFinite(value))) throw new Error('유효한 숫자를 입력해 주세요.');
          editor.updateElementProperties(id, { [key]: value }); onEdited?.(); refresh();
        }); });
        controls.push({ key, input });
      }
    }
    for (const { key, input } of controls) {
      if (document.activeElement !== input) input.value = current?.[key] ?? '';
    }
  };
  select.addEventListener('change', () => { void run(async () => {
    const editor = getEditor(); if (editor && select.value) editor.selectElements([select.value]); refresh();
  }); });
  return { element, refresh };
}
